var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHelpCircle = function SvgHelpCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.043 10a8.958 8.958 0 1 1 17.917 0 8.958 8.958 0 0 1-17.917 0m8.958-2.917a.833.833 0 0 0-.833.833.833.833 0 1 1-1.667 0 2.5 2.5 0 1 1 4.604 1.352c-.15.234-.326.455-.481.648l-.085.106c-.129.16-.243.3-.35.446-.263.362-.354.595-.354.781a.833.833 0 1 1-1.667 0c0-.734.36-1.33.674-1.761.133-.183.28-.364.409-.524l.074-.092c.155-.192.28-.353.378-.506a.833.833 0 0 0-.702-1.283m-.003 5.833a.83.83 0 0 0-.83.833c0 .46.371.834.83.834h.007c.458 0 .83-.373.83-.834a.83.83 0 0 0-.83-.833z",
    clipRule: "evenodd"
  })));
};
export default SvgHelpCircle;